<template>
  <div class="modal fade" id="feedback-modal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header modal-header-blue-bg">
          <div class="title-with-icon">
            <div class="title-with-icon__icon title-with-icon__icon-white title-with-icon__icon_exclamation"></div>
            <div class="title-with-icon__title">Оставьте обратную связь</div>
          </div>
          <button id="modal-close" type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p class="mb-4 mt-4">
            Перед прохождением итогового теста по программе необходимо оставить обратную связь.
          </p>
          <div class="d-flex justify-content-end">
            <a :href="feedbackUrl" target="_blank" class="btn btn-primary btn-with-icon">
              <span>
                Перейти к форме обратной связи
                <img class="icon left" src="/pic/icon-chevron-right.svg" />
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "ModalFeedback",
  data() {
    return {
      feedbackUrl: '/forms/feedback'
    }
  },
  methods: {
    show() {
      $('#feedback-modal').modal('show');
    },
    hide() {
      $('#feedback-modal').modal('hide');
    }
  }
}
</script>

<style scoped>

</style>

